import { useContext } from 'react';
import { VideoContext } from '../../../alucio/components/AlucioVideoProvider/VideoProvider';
export default function useVideoContext() {
    const context = useContext(VideoContext);
    if (!context) {
        throw new Error('useVideoContext must be used within a VideoProvider');
    }
    return context;
}
//# sourceMappingURL=useVideoContext.js.map